{
  "sitemap": {
    "sitemap": "Seitenverzeichnis",
    "title": {
      "create": "Sitemap erstellen",
      "edit": "Sitemap bearbeiten"
    },
    "name": "Name",
    "key": "Schlüsselcode (3 Buchstaben)",
    "colour_of_label": "Farbe des Etiketts",
    "versions": "Versionen",
    "there_are_no_versions": "Es gibt keine Versionen auf dieser Sitemap",
    "add_version": "Version hinzufügen",
    "map_order": "Reihenfolge der Karten"
  },
  "sitemapVersion": {
    "sitemapVersion": "Version der Sitemap",
    "title": {
      "create": "Erstellen Sie eine Sitemap-Version",
      "edit": "Eine Sitemap-Version bearbeiten"
    },
    "version": "Version",
    "name": "Name",
    "level_abbreviation": "Abkürzung der Ebene (max. 3 Zeichen)",
    "level_index": "Index",
    "tiles": "Kacheln",
    "upload_tiles": "Kacheln hochladen",
    "remove_tiles": "Kacheln entfernen",
    "style": "Stil",
    "upload_style": "Stil hochladen",
    "remove_style": "Stil entfernen",
    "levels": "Stufen",
    "there_are_no_levels": "In dieser Version gibt es keine Levels",
    "add_level": "Level hinzufügen",
    "uploading_tiles": "{{ level }} wird hochgeladen",
    "retry": "Versuchen Sie es erneut",
    "enter_level_name": "Geben Sie den Namen der Ebene ein",
    "level_index_must_be_unique": "Der Ebenenindex muss eindeutig sein",
    "Pending": "Ausstehend",
    "Active": "Aktiv",
    "Deleted": "Gelöscht",
    "Uploading": "Wird hochgeladen",
    "Extracting": "Extrahieren",
    "Reviewing": "Überarbeiten",
    "Tiling": "Fliesen verlegen",
    "Failed": "Fehlgeschlagen",
    "deleteVersionWarning": "Eine Sitemap muss mindestens eine Version haben. Bitte erstellen Sie vor dem Löschen eine neue Version"
  },
  "sitemapVersionLevel": {
    "sitemapVersionLevel": "Versionsebene der Sitemap",
    "level": "Stufe"
  },
  "levelsReassignmentDialog": {
    "title": "Neuzuweisung eines Levels",
    "paragraph1": "Sie sind im Begriff, einige Ebenen zu entfernen, aber einige Kartenobjekte sind möglicherweise auf diesen Ebenen vorhanden.",
    "paragraph2": "Auf welche Ebenen möchtest du sie verschieben?"
  },
  "cad": {
    "cadFile": "CAD-Datei",
    "remove": "DWG-Datei",
    "upload": "Laden Sie eine DWG-Datei hoch",
    "coordinateSystem": "Koordinatensystem",
    "preset": {
      "title": "Voreinstellung für die Konfiguration",
      "placeholder": "Wählen Sie aus den vorhandenen Sitemap-Versionsebenen"
    }
  },
  "sitemap_default": {
    "floor": "Erdgeschoss"
  }
}